import { actionCreators } from 'react/api/actions/quickAssignment';

export const assignDriverToRoute = (driver, routeId, dispatch) => {
  if (!driver?.id || !routeId || !dispatch) {
    throw new Error('Missing required parameters for driver assignment');
  }

  const model = new App.Models.RouteDriverAssignment();
  const data = {
    route: {
      id: routeId
    },
    driver: {
      id: driver.id
    }
  };

  const removeLoading = () => {
    dispatch(
      actionCreators.toggleAssignLoading({
        triggerLoading: false,
        routeId,
        key: 'driver'
      })
    );
  };

  const success = (assignment) => {
    Object.assign(driver, {
      assignmentId: assignment.id
    });

    removeLoading();
    dispatch(
      actionCreators.assignDriver({
        assignmentId: assignment.id,
        driver,
        routeId
      })
    );
  };

  const error = () => {
    removeLoading();
  };

  dispatch(
    actionCreators.toggleAssignLoading({
      triggerLoading: true,
      text: driver.name,
      key: 'driver',
      routeId
    })
  );

  model.assignToRoute({ list: data }, success, error);
};

export const assignHelperToRoute = (driver, routeId, dispatch) => {
  const model = new App.Models.RouteHelperAssignment();
  const data = {
    route: {
      id: routeId
    },
    helper: {
      id: driver.id
    }
  };

  const removeLoading = () => {
    dispatch(
      actionCreators.toggleAssignLoading({
        triggerLoading: false,
        routeId,
        key: 'helper'
      })
    );
  };

  const success = (assignment) => {
    Object.assign(driver, {
      assignmentId: assignment.id
    });

    removeLoading();
    dispatch(
      actionCreators.assignHelper({
        assignmentId: assignment.id,
        helper: driver,
        routeId
      })
    );
  };

  const error = () => {
    removeLoading();
  };

  dispatch(
    actionCreators.toggleAssignLoading({
      triggerLoading: true,
      text: driver.name,
      key: 'helper',
      routeId
    })
  );

  model.assignToRoute({ list: data }, success, error);
};

export const driverCanBeAssigned = (driver, drivers) => {
  if (!driver || !Array.isArray(drivers)) return false;

  const isAssigned = drivers.some((item) => item.id === driver.id);

  if (drivers.length > 0 && isAssigned) {
    new Greenmile.Components.AlertModal(
      'SpeedAssignment.driverAlreadyAssigned'
    ).show();
    return false;
  }

  return true;
};
